module.exports = __webpack_public_path__ + "img/cyberpunk.227ff371.png";